import React from "react";

const CountryDropdownList = [
    {
      value: 'Afghanistan',
      label: 'Afghanistan',
    },
    {
      value: 'Albania',
      label: 'Albania',
    },
    {
      value: 'Algeria',
      label: 'Algeria',
    },
    {
      value: 'American Samoa',
      label: 'American Samoa',
    },
    {
      value: 'Andorra',
      label: 'Andorra',
    },
    {
      value: 'Angola',
      label: 'Angola',
    },
    {
      value: 'Anguilla',
      label: 'Anguilla',
    },
    {
      value: 'Antigua',
      label: 'Antigua',
    },
    {
      value: 'Argentina',
      label: 'Argentina',
    },
    {
      value: 'Armenia',
      label: 'Armenia',
    },
    {
      value: 'Aruba',
      label: 'Aruba',
    },
    {
      value: 'Australia',
      label: 'Australia',
    },
    {
      value: 'Austria',
      label: 'Austria',
    },
    {
      value: 'Azerbaijan',
      label: 'Azerbaijan',
    },
    {
      value: 'Bahamas',
      label: 'Bahamas',
    },
    {
      value: 'Bahrain',
      label: 'Bahrain',
    },
    {
      value: 'Bangladesh',
      label: 'Bangladesh',
    },
    {
      value: 'Barbados',
      label: 'Barbados',
    },
    {
      value: 'Belarus',
      label: 'Belarus',
    },
    {
      value: 'Belgium',
      label: 'Belgium',
    },
    {
      value: 'Belize',
      label: 'Belize',
    },
    {
      value: 'Benin',
      label: 'Benin',
    },
    {
      value: 'Bermuda',
      label: 'Bermuda',
    },
    {
      value: 'BES Islands',
      label: 'BES Islands',
    },
    {
      value: 'Bhutan',
      label: 'Bhutan',
    },
    {
      value: 'Bolivia',
      label: 'Bolivia',
    },
    {
      value: 'Bosnia-Herzegovina',
      label: 'Bosnia-Herzegovina',
    },
    {
      value: 'Botswana',
      label: 'Botswana',
    },
    {
      value: 'Brazil',
      label: 'Brazil',
    },
    {
      value: 'British Virgin Islands',
      label: 'British Virgin Islands',
    },
    {
      value: 'Brunei',
      label: 'Brunei',
    },
    {
      value: 'Bulgaria',
      label: 'Bulgaria',
    },
    {
      value: 'Burkina Faso',
      label: 'Burkina Faso',
    },
    {
      value: 'Burundi',
      label: 'Burundi',
    },
    {
      value: 'Cambodia',
      label: 'Cambodia',
    },
    {
      value: 'Cameroon',
      label: 'Cameroon',
    },
    {
      value: 'Canada',
      label: 'Canada',
    },
    {
      value: 'Cape Verde Islands',
      label: 'Cape Verde Islands',
    },
    {
      value: 'Cayman Islands',
      label: 'Cayman Islands',
    },
    {
      value: 'Central African Republic',
      label: 'Central African Republic',
    },
    {
      value: 'Chad',
      label: 'Chad',
    },
    {
      value: 'Chile',
      label: 'Chile',
    },
    {
      value: 'China',
      label: 'China',
    },
    {
      value: 'Christmas Island',
      label: 'Christmas Island',
    },
    {
      value: 'Cocos Islands',
      label: 'Cocos Islands',
    },
    {
      value: 'Colombia',
      label: 'Colombia',
    },
    {
      value: 'Comoro Islands',
      label: 'Comoro Islands',
    },
    {
      value: 'Congo',
      label: 'Congo',
    },
    {
      value: 'Costa Rica',
      label: 'Costa Rica',
    },
    {
      value: 'Cook Islands',
      label: 'Cook Islands',
    },
    {
      value: 'Croatia',
      label: 'Croatia',
    },
    {
      value: 'Cuba',
      label: 'Cuba',
    },
    {
      value: 'Curacao',
      label: 'Curacao',
    },
    {
      value: 'Cyprus',
      label: 'Cyprus',
    },
    {
      value: 'Czech Republic',
      label: 'Czech Republic',
    },
    {
      value: 'Democratic Republic of Congo',
      label: 'Democratic Republic of Congo',
    },
    {
      value: 'Denmark',
      label: 'Denmark',
    },
    {
      value: 'Djibouti',
      label: 'Djibouti',
    },
    {
      value: 'Dominica',
      label: 'Dominica',
    },
    {
      value: 'East Timor',
      label: 'East Timor',
    },
    {
      value: 'Ecuador',
      label: 'Ecuador',
    },
    {
      value: 'Egypt',
      label: 'Egypt',
    },
    {
      value: 'El Salvador',
      label: 'El Salvador',
    },
    {
      value: 'Equatorial Guinea',
      label: 'Equatorial Guinea',
    },
    {
      value: 'Eritrea',
      label: 'Eritrea',
    },
    {
      value: 'Estonia',
      label: 'Estonia',
    },
    {
      value: 'Ethiopia',
      label: 'Ethiopia',
    },
    {
      value: 'Europe (Lloyd\'s Insurance Company SA)',
      label: 'Europe (Lloyd\'s Insurance Company SA)',
    },
    {
      value: 'Falkland Islands',
      label: 'Falkland Islands',
    },
    {
      value: 'Fiji',
      label: 'Fiji',
    },
    {
      value: 'Finland',
      label: 'Finland',
    },
    {
      value: 'France',
      label: 'France',
    },
    {
      value: 'French Guiana',
      label: 'French Guiana',
    },
    {
      value: 'French Polynesia',
      label: 'French Polynesia',
    },
    {
      value: 'Gabon',
      label: 'Gabon',
    },
    {
      value: 'Gambia',
      label: 'Gambia',
    },
    {
      value: 'Georgia',
      label: 'Georgia',
    },
    {
      value: 'Germany',
      label: 'Germany',
    },
    {
      value: 'Ghana',
      label: 'Ghana',
    },
    {
      value: 'Gibraltar',
      label: 'Gibraltar',
    },
    {
      value: 'Greece',
      label: 'Greece',
    },
    {
      value: 'Greenland',
      label: 'Greenland',
    },
    {
      value: 'Grenada',
      label: 'Grenada',
    },
    {
      value: 'Guadeloupe',
      label: 'Guadeloupe',
    },
    {
      value: 'Guam',
      label: 'Guam',
    },
    {
      value: 'Guatemala',
      label: 'Guatemala',
    },
    {
      value: 'Guernsey',
      label: 'Guernsey',
    },
    {
      value: 'Guinea',
      label: 'Guinea',
    },
    {
      value: 'Guinea-Bissau',
      label: 'Guinea-Bissau',
    },
    {
      value: 'Guyana',
      label: 'Guyana',
    },
    {
      value: 'Haiti',
      label: 'Haiti',
    },
    {
      value: 'Honduras',
      label: 'Honduras',
    },
    {
      value: 'Hong Kong SAR',
      label: 'Hong Kong SAR',
    },
    {
      value: 'Hungary',
      label: 'Hungary',
    },
    {
      value: 'Iceland',
      label: 'Iceland',
    },
    {
      value: 'India',
      label: 'India',
    },
    {
      value: 'Indonesia',
      label: 'Indonesia',
    },
    {
      value: 'Iran',
      label: 'Iran',
    },
    {
      value: 'Iraq',
      label: 'Iraq',
    },
    {
      value: 'Ireland',
      label: 'Ireland',
    },
    {
      value: 'Isle of Man',
      label: 'Isle of Man',
    },
    {
      value: 'Israel',
      label: 'Israel',
    },
    {
      value: 'Italy',
      label: 'Italy',
    },
    {
      value: 'Ivory Coast',
      label: 'Ivory Coast',
    },
    {
      value: 'Jamaica',
      label: 'Jamaica',
    },
    {
      value: 'Japan',
      label: 'Japan',
    },
    {
      value: 'Jersey',
      label: 'Jersey',
    },
    {
      value: 'Jordan',
      label: 'Jordan',
    },
    {
      value: 'Kazakhstan',
      label: 'Kazakhstan',
    },
    {
      value: 'Kenya',
      label: 'Kenya',
    },
    {
      value: 'Kiribati',
      label: 'Kiribati',
    },
    {
      value: 'Kosovo',
      label: 'Kosovo',
    },
    {
      value: 'Kuwait',
      label: 'Kuwait',
    },
    {
      value: 'Kyrgyzstan',
      label: 'Kyrgyzstan',
    },
    {
      value: 'Labuan',
      label: 'Labuan',
    },
    {
      value: 'Laos',
      label: 'Laos',
    },
    {
      value: 'Latvia',
      label: 'Latvia',
    },
    {
      value: 'Lebanon',
      label: 'Lebanon',
    },
    {
      value: 'Lesotho',
      label: 'Lesotho',
    },
    {
      value: 'Liberia',
      label: 'Liberia',
    },
    {
      value: 'Libya',
      label: 'Libya',
    },
    {
      value: 'Liechtenstein',
      label: 'Liechtenstein',
    },
    {
      value: 'Lithuania',
      label: 'Lithuania',
    },
    {
      value: 'Luxembourg',
      label: 'Luxembourg',
    },
    {
      value: 'Macau',
      label: 'Macau',
    },
    {
      value: 'Madagascar',
      label: 'Madagascar',
    },
    {
      value: 'Malawi',
      label: 'Malawi',
    },
    {
      value: 'Malaysia',
      label: 'Malaysia',
    },
    {
      value: 'Maldives',
      label: 'Maldives',
    },
    {
      value: 'Mali',
      label: 'Mali',
    },
    {
      value: 'Malta',
      label: 'Malta',
    },
    {
      value: 'Marshall Islands',
      label: 'Marshall Islands',
    },
    {
      value: 'Martinique',
      label: 'Martinique',
    },
    {
      value: 'Mauritania',
      label: 'Mauritania',
    },
    {
      value: 'Mauritius',
      label: 'Mauritius',
    },
    {
      value: 'Mayotte',
      label: 'Mayotte',
    },
    {
      value: 'Mexico',
      label: 'Mexico',
    },
    {
      value: 'Micronesia',
      label: 'Micronesia',
    },
    {
      value: 'Moldova',
      label: 'Moldova',
    },
    {
      value: 'Monaco',
      label: 'Monaco',
    },
    {
      value: 'Mongolia',
      label: 'Mongolia',
    },
    {
      value: 'Montenegro',
      label: 'Montenegro',
    },
    {
      value: 'Montserrat',
      label: 'Montserrat',
    },
    {
      value: 'Morocco',
      label: 'Morocco',
    },
    {
      value: 'Mozambique',
      label: 'Mozambique',
    },
    {
      value: 'Myanmar',
      label: 'Myanmar',
    },
    {
      value: 'Namibia',
      label: 'Namibia',
    },
    {
      value: 'Nauru',
      label: 'Nauru',
    },
    {
      value: 'Nepal',
      label: 'Nepal',
    },
    {
      value: 'Netherlands',
      label: 'Netherlands',
    },
    {
      value: 'New Caledonia',
      label: 'New Caledonia',
    },
    {
      value: 'New Zealand',
      label: 'New Zealand',
    },
    {
      value: 'Nicaragua',
      label: 'Nicaragua',
    },
    {
      value: 'Niger',
      label: 'Niger',
    },
    {
      value: 'Nigeria',
      label: 'Nigeria',
    },
    {
      value: 'Norfolk Island',
      label: 'Norfolk Island',
    },
    {
      value: 'North Korea',
      label: 'North Korea',
    },
    {
      value: 'Northern Mariana Islands',
      label: 'Northern Mariana Islands',
    },
    {
      value: 'Norway',
      label: 'Norway',
    },
    {
      value: 'Oman',
      label: 'Oman',
    },
    {
      value: 'Pakistan',
      label: 'Pakistan',
    },
    {
      value: 'Palestine',
      label: 'Palestine',
    },
    {
      value: 'Panama',
      label: 'Panama',
    },
    {
      value: 'Papua New Guinea',
      label: 'Papua New Guinea',
    },
    {
      value: 'Paraguay',
      label: 'Paraguay',
    },
    {
      value: 'Peru',
      label: 'Peru',
    },
    {
      value: 'Palau',
      label: 'Palau',
    },
    {
      value: 'Philippines',
      label: 'Philippines',
    },
    {
      value: 'Poland',
      label: 'Poland',
    },
    {
      value: 'Portugal (inc dependencies)',
      label: 'Portugal (inc dependencies)',
    },
    {
      value: 'Puerto Rico',
      label: 'Puerto Rico',
    },
    {
      value: 'Qatar',
      label: 'Qatar',
    },
    {
      value: 'Reunion',
      label: 'Reunion',
    },
    {
      value: 'Romania',
      label: 'Romania',
    },
    {
      value: 'Russia',
      label: 'Russia',
    },
    {
      value: 'Rwanda',
      label: 'Rwanda',
    },
    {
      value: 'Saint Barthelemy',
      label: 'Saint Barthelemy',
    },
    {
      value: 'Saint Martin (Dutch)',
      label: 'Saint Martin (Dutch)',
    },
    {
      value: 'Saint Martin (French)',
      label: 'Saint Martin (French)',
    },
    {
      value: 'Samoa',
      label: 'Samoa',
    },
    {
      value: 'San Marino',
      label: 'San Marino',
    },
    {
      value: 'Saudi Arabia',
      label: 'Saudi Arabia',
    },
    {
      value: 'Senegal',
      label: 'Senegal',
    },
    {
      value: 'Serbia',
      label: 'Serbia',
    },
    {
      value: 'Seychelles',
      label: 'Seychelles',
    },
    {
      value: 'Sierra Leone',
      label: 'Sierra Leone',
    },
    {
      value: 'Singapore',
      label: 'Singapore',
    },
    {
      value: 'Slovakia',
      label: 'Slovakia',
    },
    {
      value: 'Slovenia',
      label: 'Slovenia',
    },
    {
      value: 'Solomon Islands',
      label: 'Solomon Islands',
    },
    {
      value: 'Somalia',
      label: 'Somalia',
    },
    {
      value: 'South Africa',
      label: 'South Africa',
    },
    {
      value: 'South Korea',
      label: 'South Korea',
    },
    {
      value: 'South Sudan',
      label: 'South Sudan',
    },
    {
      value: 'Spain (inc dependencies)',
      label: 'Spain (inc dependencies)',
    },
    {
      value: 'Sri Lanka',
      label: 'Sri Lanka',
    },
    {
      value: 'St Helena',
      label: 'St Helena',
    },
    {
      value: 'St Kitts & Nevis',
      label: 'St Kitts & Nevis',
    },
    {
      value: 'St Lucia',
      label: 'St Lucia',
    },
    {
      value: 'Sudan',
      label: 'Sudan',
    },
    {
      value: 'Suriname',
      label: 'Suriname',
    },
    {
      value: 'Swaziland',
      label: 'Swaziland',
    },
    {
      value: 'Sweden',
      label: 'Sweden',
    },
    {
      value: 'Switzerland',
      label: 'Switzerland',
    },
    {
      value: 'Syria',
      label: 'Syria',
    },
    {
      value: 'Taiwan',
      label: 'Taiwan',
    },
    {
      value: 'Tajikistan',
      label: 'Tajikistan',
    },
    {
      value: 'Tanzania',
      label: 'Tanzania',
    },
    {
      value: 'Thailand',
      label: 'Thailand',
    },
    {
      value: 'Togo',
      label: 'Togo',
    },
    {
      value: 'Tonga',
      label: 'Tonga',
    },
    {
      value: 'Trinidad & Tobago',
      label: 'Trinidad & Tobago',
    },
    {
      value: 'Tunisia',
      label: 'Tunisia',
    },
    {
      value: 'Turkey',
      label: 'Turkey',
    },
    {
      value: 'Turkmenistan',
      label: 'Turkmenistan',
    },
    {
      value: 'Turks & Caicos',
      label: 'Turks & Caicos',
    },
    {
      value: 'Tuvalu',
      label: 'Tuvalu',
    },
    {
      value: 'Uganda',
      label: 'Uganda',
    },
    {
      value: 'United Kingdom',
      label: 'United Kingdom',
    },
    {
      value: 'Ukraine',
      label: 'Ukraine',
    },
    {
      value: 'United Arab Emirates',
      label: 'United Arab Emirates',
    },
    {
      value: 'Uruguay',
      label: 'Uruguay',
    },
    {
      value: 'US',
      label: 'US',
    },
    {
      value: 'Uzbekistan',
      label: 'Uzbekistan',
    },
    {
      value: 'Vanuatu',
      label: 'Vanuatu',
    },
    {
      value: 'Vatican City',
      label: 'Vatican City',
    },
    {
      value: 'Venezuela',
      label: 'Venezuela',
    },
    {
      value: 'Vietnam',
      label: 'Vietnam',
    },
    {
      value: 'Wallis & Futuna',
      label: 'Wallis & Futuna',
    },
    {
      value: 'Western Sahara',
      label: 'Western Sahara',
    },
    {
      value: 'Yemen',
      label: 'Yemen',
    },
    {
      value: 'Zambia',
      label: 'Zambia',
    },
    {
      value: 'Zimbabwe',
      label: 'Zimbabwe',
    }
  ];

export default CountryDropdownList;